import { render, staticRenderFns } from "./YA_TelegramContent2.vue?vue&type=template&id=2d603040&scoped=true"
import script from "./YA_TelegramContent2.vue?vue&type=script&lang=js"
export * from "./YA_TelegramContent2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d603040",
  null
  
)

export default component.exports